import * as CubeTree from '../../cubeTree/index';
import { StageEvent } from '../../message/index';
import NextTick from '../../utils/nextTick';
import Update from '../../update/index';
import Select from '../../interaction/select/index';
import Visit from '../../interaction/visit';

interface AddEventParams {
    eventFrom: string,
    taskList: Array<FreeObjMap>,
    done?: () => void
}

function addSingleCube(): void {
    StageEvent.on('addNew', async (params: AddEventParams): Promise<void> => {
        if (params.eventFrom === 'stage') {
            return;
        }
        let taskList: Array<AddTask> = params.taskList.map((task: FreeObjMap): AddTask => {
            return {
                type: task.type === 'shelves' ? 'shelf' : task.type,
                cubeData: task.cubeData,
                extendParams: {
                    addType: 'normal'
                }
            };
        });

        let addCubes: Array<CubeId> = await Visit.Add.runAddTaskQueue(taskList);

        NextTick(() => {
            Select.addGroup(addCubes);
            Update.updateEnd();
            setTimeout(() => {
                Select.panelSelectSync();
                params.done && params.done();
            }, 310);
        });
        Visit.History.stackIn({
            type: 'add',
            data: addCubes
        });
    });
}

export {
    addSingleCube
};
